import Vue from "vue";
import SitecoreExpEditorPlugin from "vue-scexpeditor";
Vue.use(SitecoreExpEditorPlugin);
